import {ReactElement, ReactNode} from "react";
import {ErrorBoundary as ReactErrorBoundary} from "react-error-boundary";

import {ErrorMessage} from "../ErrorMessage/ErrorMessage";

interface ErrorBoundaryProps {
  children: ReactNode;
  fallbackText?: string;
  buttonToRefresh?: boolean;
}

export function ErrorBoundary({
  children,
  fallbackText = "Une erreur est survenue, veuillez réessayer",
  buttonToRefresh = true,
}: ErrorBoundaryProps): ReactElement {
  return (
    <ReactErrorBoundary
      fallback={
        <ErrorMessage text={fallbackText} buttonToRefresh={buttonToRefresh} />
      }>
      {children}
    </ReactErrorBoundary>
  );
}
